(function () {
    'use strict';
    angular.module('ib-pmt-wine-club-module').constant('PmtWineClubConstants', {
        'IMAGES': {
            'WINECLUB_IMG':{
                'es':'/iberia-web-content/imagenes/banners/wineclub-bki/bki_confirm_wineclub_christmas_es.jpg',
                'ca':'/iberia-web-content/imagenes/banners/wineclub-bki/bki_confirm_wineclub_christmas_es.jpg',
                'en':'/iberia-web-content/imagenes/banners/wineclub-bki/bki_confirm_wineclub_christmas_en.jpg',
                'de':'/iberia-web-content/imagenes/banners/wineclub-bki/bki_confirm_wineclub_christmas_en.jpg',
                'fr':'/iberia-web-content/imagenes/banners/wineclub-bki/bki_confirm_wineclub_christmas_en.jpg',
                'it':'/iberia-web-content/imagenes/banners/wineclub-bki/bki_confirm_wineclub_christmas_en.jpg',
                'pt':'/iberia-web-content/imagenes/banners/wineclub-bki/bki_confirm_wineclub_christmas_en.jpg',
                'nl':'/iberia-web-content/imagenes/banners/wineclub-bki/bki_confirm_wineclub_christmas_en.jpg',
                'ru':'/iberia-web-content/imagenes/banners/wineclub-bki/bki_confirm_wineclub_christmas_en.jpg',
                'ja':'/iberia-web-content/imagenes/banners/wineclub-bki/bki_confirm_wineclub_christmas_en.jpg',
                'zh':'/iberia-web-content/imagenes/banners/wineclub-bki/bki_confirm_wineclub_christmas_en.jpg',
                'default':'/iberia-web-content/imagenes/banners/wineclub-bki/bki_confirm_wineclub.jpg',
            }
        }
    });
})(window);
